import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDebouncedCallback } from "use-debounce";
import { useTeamsOptionsInfiniteQuery } from "./Teams.state";
import { FormAutocompleteMultiple } from "../common/FormAutocomplete";

const TeamOnlySelect = ({
  setValue,
  mapLabel = "name",
  placeholder,
  disableClearable = true,
  loading = false,
}) => {
  const { t } = useTranslation();
  const [term, setTerm] = useState("");
  const [selectedTeams, setSelectedTeams] = useState([]);
  const onRemoteSearch = useDebouncedCallback((query) => {
    setTerm(query);
  }, 600);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
  } = useTeamsOptionsInfiniteQuery({ term });

  const options = useMemo(() => {
    const teams = data?.pages.flatMap((page) => page.teams) || [];
    return teams.filter((team, index, source) => {
      return source.findIndex((item) => item.id === team.id) === index;
    });
  }, [data]);

  const onNextPage = useCallback(async () => {
    if (isFetching || !hasNextPage || term) {
      return;
    }
    await fetchNextPage();
  }, [fetchNextPage, hasNextPage, isFetching, term]);

  return (
    <FormAutocompleteMultiple
      stateful={false}
      loading={isFetching || loading}
      options={options}
      mapLabel={mapLabel}
      mapValue="id"
      disableClearable={disableClearable}
      size="small"
      placeholder={placeholder || t("Select team...")}
      onChange={(_, values) => {
        setSelectedTeams(values);
        const selectedTeam = values?.[values.length - 1];
        if (!selectedTeam) {
          return;
        }
        setValue(selectedTeam);
        setSelectedTeams([]);
      }}
      value={selectedTeams}
      onRemoteSearch={onRemoteSearch}
      onNextPage={onNextPage}
    />
  );
};

export default TeamOnlySelect;
